import React, { ChangeEvent } from 'react';
import { Box, Text, Checkbox } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { useSeekersFilters } from '../filters/SeekersFiltersContext';
import { SearchAndSortProps } from './searchAndSortType';

export const KioskCandidatesView = ({ tempSearchAndSortType, setTempSearchAndSortTypes }: SearchAndSortProps): JSX.Element => {
  const { t } = useTranslation();
  const { setIsFromSearchAndSort } = useSeekersFilters();

  const onHandleKiosk = (kioskEnabled: boolean) => {
    const updatedFilters = {
      ...tempSearchAndSortType,
      kioskEnabled,
    };
    setIsFromSearchAndSort(true);
    setTempSearchAndSortTypes(updatedFilters);
  };
  return (
    <Box>
      <Checkbox
        data-testid="kioskCheckBox"
        isChecked={tempSearchAndSortType.kioskEnabled}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onHandleKiosk(e.target.checked)}
      >
        <Text
          px={3}
          style={{
            fontSize: '14px',
            fontWeight: 'normal',
          }}
        >
          {t('searchAndSort.kiosk')}
        </Text>
      </Checkbox>
    </Box>
  );
};
